import { graphql, HttpResponse } from 'msw'
import { type EnrollmentJointHomeData, type EnrollmentJointHomeSubmitOutput } from '../../../../models'

export const getEnrollmentJointHomeDataMock: EnrollmentJointHomeData = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/joint/',
}

export const submitEnrollmentJointHomeDataMock: EnrollmentJointHomeSubmitOutput = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/joint/get-started',
}

export const mockGetEnrollmentJointHomeData = graphql.mutation('getEnrollmentJointHomeData', () => {
  return HttpResponse.json({ data: { submitEnrollment: getEnrollmentJointHomeDataMock } })
})

export const mockSubmitEnrollmentJointHomeData = graphql.mutation('submitEnrollmentJointHomeData', () => {
  return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentJointHomeDataMock } })
})

export const mockEnrollmentJointHome = [mockGetEnrollmentJointHomeData, mockSubmitEnrollmentJointHomeData]
